import { Grid, TextField, InputAdornment, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';

export default function ManualDetailDialog({
    showDialogDetail,
    setShowDialogDetail,
    nameAdmin,
    date,
    time
}) {
  return (
    <Dialog
        fullWidth
        open={showDialogDetail}
        onClose={() => setShowDialogDetail(false)}
    >
        <DialogTitle>
            <span>
                รายละเอียดการรับชำระเงิน <PriceCheckIcon color='success'/>
            </span>
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                <Grid container spacing={2} sx={{ textAlign: 'center' }}>
                  <Grid item xs={12} md={12} sx={{ mt: 2 }}>
                    <TextField
                      fullWidth
                      disabled
                      id="outlined-disabled"
                      label="ชื่อ-นามสกุล"
                      value={nameAdmin || '-'}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>
                            <AccountCircleIcon/>
                          </InputAdornment>
                        ),
                        sx: { input: { fontWeight: 500 }}
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                    <TextField
                      disabled
                      fullWidth
                      id="outlined-disabled"
                      label="วันที่รับชำระ"
                      value={date || '-'}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>
                            <CalendarMonthIcon/>
                          </InputAdornment>
                        ),
                        sx: { input: { fontWeight: 500 }}
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                    <TextField
                      disabled
                      fullWidth
                      id="outlined-disabled"
                      label="เวลาที่รับชำระ"
                      value={time || '-'}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>
                            <AccessTimeFilledIcon/>
                          </InputAdornment>
                        ),
                        sx: { input: { fontWeight: 500 }}
                      }}
                    />
                  </Grid>
                </Grid>
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button
                onClick={() => setShowDialogDetail(false)}
                color='error'
            >
                ปิด
            </Button>
        </DialogActions>
    </Dialog>
  )
}
